module.exports = __webpack_public_path__ + "static/img/hua14.5884124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua14.png
// module id = bs/3
// module chunks = 22